//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getGameBigWinList} from '@/common/api/normal.js'
import NewsScroll from "./components/news-scroll"
import gameCont from '../game/index.vue'
export default {
  name: "home",
  components: {gameCont,NewsScroll},
  data() {
    return {
      gameTypeCode: '-1',
      prizeList:[],
      prizeVisible:false,
    }
  },
  created() {
    this.getWinLists();
  },
  methods: {
    getWinLists() { 
      if (sessionStorage.getItem('getGameBigWinList')) {
          this.prizeList = JSON.parse(sessionStorage.getItem('getGameBigWinList'));
      } else {
          getGameBigWinList({'pageSize':60}).then(([data, err, res]) => {
              if (!err) {
                  this.prizeList = data.list;
                  sessionStorage.setItem("getGameBigWinList", JSON.stringify(data.list));
              }
          })
      }
    },
    handleGoDetail(item) {
      var winDetails = JSON.stringify(item);
      sessionStorage.setItem("betSlip", winDetails);
      this.$router.push({ path: '/betSlip'})
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/pages-0.vue